import { render, staticRenderFns } from "./reason.vue?vue&type=template&id=fcd6985c&scoped=true"
import script from "./reason.vue?vue&type=script&lang=js"
export * from "./reason.vue?vue&type=script&lang=js"
import style0 from "./reason.vue?vue&type=style&index=0&id=fcd6985c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd6985c",
  null
  
)

export default component.exports